import { Fragment } from 'react'
import PropTypes from 'prop-types'
import Mask from 'vanilla-masker'

const setPhoneMask = (text) => {
  switch (text.length) {
    case 11:
      return '(99) 99999-9999'

    case 10:
      return '(99) 9999-9999'

    case 9:
      return '99999-9999'

    default:
      return '9999-9999'
  }
}

const MaskedText = ({ type, text, rule }) => {
  if (!text) {
    return null
  }

  let mask

  switch (type) {
    case 'phone':
      mask = setPhoneMask(text)
      break

    case 'cpf':
      mask = '999.999.999-99'
      break

    default:
      mask = rule
      break
  }

  return <Fragment>{Mask.toPattern(text, mask)}</Fragment>
}

MaskedText.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  rule: PropTypes.string
}

export default MaskedText
